const time = {
  intlDateTime: '{{val, datetime}}'
}

export default time
